module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/database.c3053fa9.svg";